/**
 * Use this class whenever there is a requirement whenever a feature context variable
 * is required to be used for both components and other objects.
 */
export class FeatureConfigUtils {
    static isSSD3Enabled = false;
    static isSSDGrocerySortPathEnabled = false;
    static isGuidedInboundEnabled = false;
    static isStagFeatureEnabled = false;
    static isSSDGroceryOVSortPathEnabled = false;
    static isPSOnGridSortPathEnabled = false;
    static isUrlSortPathEnabled = false;
    static isRushSortPathEnabled = false;
    static isInductAreaCapacityManagementEnabled = false;
    static isInductAreaCapacityVisibilityEnabled = false;
    static isLHYResourceCreationEnabled = false;

    static getIsSSD3EnabledStation() {
        return FeatureConfigUtils.isSSD3Enabled;
    }

    static setIsSSD3EnabledStation(isEnabled) {
        FeatureConfigUtils.isSSD3Enabled = isEnabled;
    }

    static getIsSSDGrocerySortPathEnabledStation() {
        return FeatureConfigUtils.isSSDGrocerySortPathEnabled;
    }

    static setIsSSDGrocerySortPathEnabledStation(isEnabled) {
        FeatureConfigUtils.isSSDGrocerySortPathEnabled = isEnabled;
    }

    static getIsSSDGroceryOVSortPathEnabledStation() {
        return FeatureConfigUtils.isSSDGroceryOVSortPathEnabled;
    }

    static setIsSSDGroceryOVSortPathEnabledStation(isEnabled) {
        return FeatureConfigUtils.isSSDGroceryOVSortPathEnabled = isEnabled;
    }

    static getIsRushSortPathEnabledStation() {
        return FeatureConfigUtils.isRushSortPathEnabled;
    }

    static setIsRushSortPathEnabledStation(isEnabled) {
        return FeatureConfigUtils.isRushSortPathEnabled = isEnabled;
    }

    static getIsInductAreaCapacityManagementEnabledStation() {
        return FeatureConfigUtils.isInductAreaCapacityManagementEnabled;
    }

    static setIsInductAreaCapacityManagementEnabledStation(isEnabled) {
        FeatureConfigUtils.isInductAreaCapacityManagementEnabled = isEnabled;
    }

    static getIsInductAreaCapacityVisibilityEnabledStation() {
        return FeatureConfigUtils.isInductAreaCapacityVisibilityEnabled;
    }

    static setIsInductAreaCapacityVisibilityEnabledStation(isEnabled) {
        FeatureConfigUtils.isInductAreaCapacityVisibilityEnabled = isEnabled;
    }

    static getIsGuidedInboundEnabledStation() {
        return FeatureConfigUtils.isGuidedInboundEnabled;
    }

    static setIsGuidedInboundEnabledStation(isEnabled) {
        FeatureConfigUtils.isGuidedInboundEnabled = isEnabled;
    }

    static setIsStagFeatureEnabledStation(isEnabled) {
        FeatureConfigUtils.isStagFeatureEnabled = isEnabled;
    }

    static getIsStagFeatureEnabledStation() {
        return FeatureConfigUtils.isStagFeatureEnabled;
    }

    static getIsPSOnGridSortPathEnabledStation() {
        return FeatureConfigUtils.isPSOnGridSortPathEnabled;
    }

    static setIsPSOnGridSortPathEnabledStation(isEnabled) {
        FeatureConfigUtils.isPSOnGridSortPathEnabled = isEnabled;
    }
    static getIsUrlSortPathEnabledStation() {
        return FeatureConfigUtils.isUrlSortPathEnabled;
    }

    static setIsUrlSortPathEnabledStation(isEnabled) {
        FeatureConfigUtils.isUrlSortPathEnabled = isEnabled;
    }

    static getIsLHYResourceCreationEnabledStation() {
        return FeatureConfigUtils.isLHYResourceCreationEnabled;
    }

    static setIsLHYResourceCreationEnabledStation(isEnabled) {
        FeatureConfigUtils.isLHYResourceCreationEnabled = isEnabled;
    }
}
